'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/10/24.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopLogin = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('商户登录')));
    return _promise2.default.all(promises);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ShopLogin, _Component);

  function ShopLogin() {
    (0, _classCallCheck3.default)(this, ShopLogin);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ShopLogin).call(this));
  }

  (0, _createClass3.default)(ShopLogin, [{
    key: 'render',
    value: function render() {
      var styles = require('./ShopLogin.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.loginPic },
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/center-geren/denglu.jpg',
            alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.loginMes },
          _react2.default.createElement(
            'div',
            { className: styles.loginH1 },
            '商户登录'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.bottomContainer },
            _react2.default.createElement(
              'a',
              { className: styles.btn + ' ' + styles.loginBtn + ' ' + styles.newBtn,
                href: 'https://craftschina.goeasy.net/',
                target: '_blank' },
              _react2.default.createElement('img', { className: styles.imgBtn,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/shoploginnew.png' })
            ),
            _react2.default.createElement(
              'a',
              { className: styles.btn + ' ' + styles.registerBtn + ' ' + styles.newBtn, href: 'https://craftschina.goeasy.net/index.aspx?actionCode=DJM00143006&eom=00029', target: '_blank' },
              _react2.default.createElement('img', {
                className: styles.imgBtn,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/productShop.png' })
            ),
            _react2.default.createElement(
              'a',
              { className: styles.btn + ' ' + styles.registerBtn + ' ' + styles.newBtn, href: 'https://craftschina.goeasy.net/index.aspx?actionCode=DJM00248606&eom=00029', target: '_blank' },
              _react2.default.createElement('img', {
                className: styles.imgBtn,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/serviceShop.png' })
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/shopannouncement', className: styles.helpbtn + ' ' + styles.mt15 + ' ' + styles.mr35, target: '_blank' },
              '商户上线准备资料'
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/helpdoc', className: styles.helpbtn + ' ' + styles.mr35 },
              '商户注册帮助'
            )
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ShopLogin;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ShopLogin;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ShopLogin/ShopLogin.js
 ** module id = 1545
 ** module chunks = 0
 **/